import { ImagesDownloadAppDownloadAppOnlyHandMobileWebp } from '@/assets/images_download-app.assets';
import LoadingComponent from '@/components/common/LoadingComponent';
import DefaultButton from '@/components/common/default/DefaultButton';
import SvgSpiritoryApp from '@/components/svg/footer/SvgSpiritoryApp';
import SvgAppleDark from '@/components/svg/footer/SvgAppleDark';
import { handleAppleStoreLink, handleGooglePlayLink } from '@/utilites/events.utils';
import { FooterEnum } from '@/types/translations/FooterEnum';
import Container from '@/components/Container';
import { useFetchFooterQrCode } from '@/useQuery/queries/qrCode';
import Image from 'next/image';
import SvgGoogleDark from '@/components/svg/footer/SvgGoogleDark';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexDownloadTheAppProps } from '@/types';
import { useRouter } from 'next/router';
import { CommonEnum } from '@/types/translations/CommonEnum';
import { IndexEnum } from '@/types/translations/IndexEnum';
export default function IndexDownloadTheApp({ userId }: IndexDownloadTheAppProps) {
  const { locale } = useRouter();
  const { translate } = useTypedTranslation<FooterEnum>('footer');
  const qrCodeFooterQuery = useFetchFooterQrCode();

  const { translate: translateCommon } = useTypedTranslation<CommonEnum>('common');
  const { translate: translateIndex } = useTypedTranslation<IndexEnum>('index');

  return (
    <Container className="tw-overflow-hidden tw-px-0">
      <div className="tw-bg-download-app-mobile tw-bg-cover tw-bg-center tw-bg-no-repeat nine:tw-h-[509px] nine:tw-rounded-[20px]">
        <div className="tw-h-full tw-w-full tw-backdrop-blur-md tw-backdrop-brightness-[60%] max-nine:tw-px-7 max-nine:tw-py-8 nine:tw-rounded-[20px] nine:tw-px-32">
          <div className="tw-relative tw-mx-auto tw-flex tw-h-full tw-justify-between tw-gap-12 max-nine:tw-flex-col nine:tw-max-w-6xl nine:tw-items-center">
            <div className="tw-w-2/4 max-nine:tw-w-full">
              <h2 className="tw-mb-3 tw-font-prata tw-text-4xl tw-font-normal tw-leading-[100%] tw-text-white max-nine:tw-text-2xl">
                {translateCommon(CommonEnum['download_the_app'])}
              </h2>
              <p className="tw-mb-6 tw-text-2xl tw-font-bold tw-leading-[100%] tw-text-white max-nine:tw-text-base">
                {translateCommon(
                  CommonEnum['buy_sell_and_discover_your_favorite_bottles_anywhere_anytime']
                )}
              </p>
              <div className="tw-flex tw-flex-col">
                <div className="tw-flex tw-items-stretch tw-gap-4">
                  <div className="max-nine:tw-hidden">
                    {qrCodeFooterQuery.isLoading ? (
                      <LoadingComponent loading={true} as="div">
                        <span className="tw-h-[150px] tw-w-[150px]">...</span>
                      </LoadingComponent>
                    ) : qrCodeFooterQuery.data ? (
                      <Image
                        src={`data:image/png;base64,${qrCodeFooterQuery.data}`}
                        alt="Spiritory QR-CODE"
                        width={150}
                        height={150}
                      />
                    ) : (
                      <SvgSpiritoryApp width={150} height={150} />
                    )}
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-stretch tw-justify-between tw-gap-2 child:tw-flex child:tw-items-center child:tw-gap-6 child:tw-rounded-xl child:tw-bg-white child:tw-px-6 child:tw-py-3">
                    <DefaultButton
                      className="tw-text-base tw-font-medium tw-text-textBlack"
                      onClick={() => handleAppleStoreLink(userId || '', locale)}
                    >
                      <SvgAppleDark />
                      <span>
                        {translate(FooterEnum['footer.download_on'])} <br />
                        <strong className="tw-text-base tw-font-bold tw-text-textBlack">
                          Apple Store
                        </strong>
                      </span>
                    </DefaultButton>
                    <DefaultButton
                      className="tw-text-base tw-font-medium tw-text-textBlack"
                      onClick={() => handleGooglePlayLink(userId || '', locale)}
                    >
                      <SvgGoogleDark />
                      <span>
                        {translate(FooterEnum['footer.download_on'])}
                        <br />
                        <strong className="tw-text-base tw-font-bold tw-text-textBlack">
                          Google Play
                        </strong>
                      </span>
                    </DefaultButton>
                  </div>
                </div>
              </div>
            </div>
            <div className="max-nine:tw-h-[315px]" />
            <div className="tw-flex tw-h-full tw-w-2/4 tw-items-center tw-justify-center max-nine:tw-absolute max-nine:-tw-bottom-8 max-nine:-tw-right-12 max-nine:tw-h-[400px] max-nine:tw-w-[300px]">
              <Image
                src={ImagesDownloadAppDownloadAppOnlyHandMobileWebp}
                alt="Download the app"
                width={422}
                height={708}
                className="tw-h-full tw-object-contain"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tw-mt-16 tw-flex tw-items-start tw-justify-between tw-gap-12 child:tw-basis-[calc(50%-48px)] max-nine:tw-flex-col max-nine:tw-gap-6 max-nine:tw-px-10">
        <div>
          <p className="tw-flex tw-flex-col tw-gap-1 tw-text-base tw-text-black max-nine:tw-gap-0.5 max-nine:tw-leading-tight">
            <strong className="tw-block tw-h-14 tw-text-base tw-font-bold max-nine:tw-mb-1 max-nine:tw-h-auto">
              {translateIndex(IndexEnum['spiritoryMarketplaceContent.0.title'])}
            </strong>
            {translateIndex(IndexEnum['spiritoryMarketplaceContent.0.description'])}
          </p>
        </div>
        <div>
          <p className="tw-flex tw-flex-col tw-gap-1 tw-text-base tw-text-black max-nine:tw-gap-0.5 max-nine:tw-leading-tight">
            <strong className="tw-block tw-h-14 tw-text-base tw-font-bold max-nine:tw-mb-1 max-nine:tw-h-auto">
              {translateIndex(IndexEnum['spiritoryMarketplaceContent.1.title'])}
            </strong>
            {translateIndex(IndexEnum['spiritoryMarketplaceContent.1.description'])}
          </p>
        </div>
        <div>
          <p className="tw-flex tw-flex-col tw-gap-1 tw-text-base tw-text-black max-nine:tw-gap-0.5 max-nine:tw-leading-tight">
            <strong className="tw-block tw-h-14 tw-text-base tw-font-bold max-nine:tw-mb-1 max-nine:tw-h-auto">
              {translateIndex(IndexEnum['spiritoryMarketplaceContent.2.title'])}
            </strong>
            {translateIndex(IndexEnum['spiritoryMarketplaceContent.2.description'])}
          </p>
        </div>
        <div>
          <p className="tw-flex tw-flex-col tw-gap-1 tw-text-base tw-text-black max-nine:tw-gap-0.5 max-nine:tw-leading-tight">
            <strong className="tw-block tw-h-14 tw-text-base tw-font-bold max-nine:tw-mb-1 max-nine:tw-h-auto">
              {translateIndex(IndexEnum['spiritoryMarketplaceContent.3.title'])}
            </strong>
            {translateIndex(IndexEnum['spiritoryMarketplaceContent.3.description'])}
          </p>
        </div>
      </div>
    </Container>
  );
}
